import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Sections from "./components/Sections";
import Footer from "./components/Footer";
import BookFlip from "./components/BookFlip";
import Poojas from "./components/Poojas";
import Festivals from "./components/Festivals";
import ContactForm from "./components/contactForm";
import Gallery from "./components/gallery";
import AppSeo from "./components/AppSeo";

// If you have other pages to navigate to:
// import DailyAarti from "./pages/DailyAarti";
// import SpecialPujas from "./pages/SpecialPujas";
// import CommunitySeva from "./pages/CommunitySeva";
import Donations from "./components/donation"; // example extra page

export default function App() {
  return (
    <>
      <BrowserRouter>
        <AppSeo />

        <Navbar />
        <Routes>
          {/* Homepage */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <Sections />
              </>
            }
          />
          <Route path="/contact" element={<ContactForm />} />
          <Route path="/book/:id" element={<BookFlip />} />
          <Route path="/poojas" element={<Poojas />} />
          <Route path="/festivals" element={<Festivals />} />
          <Route path="/gallery" element={<Gallery />} />
          <Route path="/donation" element={<Donations />} />

          {/* Other pages for your feature redirects */}
          {/* <Route path="/daily-aarti" element={<DailyAarti />} />
        <Route path="/special-pujas" element={<SpecialPujas />} />
        <Route path="/community-seva" element={<CommunitySeva />} />
        <Route path="/donations" element={<Donations />} /> */}
        </Routes>
        <Footer />
      </BrowserRouter>
    </>

  );
}
